var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24268_9330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.19 12.08C12.6 12.08 12.94 12.42 12.94 12.83C12.94 13.24 12.61 13.58 12.19 13.58H7.83C7.42 13.58 7.08 13.24 7.08 12.83C7.08 12.42 7.41 12.08 7.83 12.08H12.19ZM9.85 8.55C10.26 8.55 10.6 8.89 10.6 9.3C10.6 9.71 10.27 10.05 9.85 10.05H7.83C7.42 10.05 7.08 9.71 7.08 9.3C7.08 8.89 7.41 8.55 7.83 8.55H9.85ZM15.44 4.68L13.27 2.54C12.91 2.2 12.44 2 11.94 2H5.88C5.39 2 4.91 2.2 4.56 2.54C4.2 2.89 4 3.37 4 3.87V16.14C4 16.64 4.2 17.12 4.56 17.46C4.91 17.81 5.39 18 5.88 18H14.12C14.61 18 15.09 17.81 15.44 17.46C15.8 17.12 16 16.64 16 16.14V6C16 5.5 15.8 5.03 15.44 4.68ZM14.51 16.14C14.51 16.23 14.47 16.32 14.4 16.39C14.33 16.46 14.23 16.5 14.12 16.5H5.88C5.77 16.5 5.67 16.46 5.6 16.39C5.53 16.32 5.49 16.23 5.49 16.14V3.87C5.49 3.78 5.53 3.69 5.6 3.62C5.65 3.56 5.72 3.53 5.8 3.51H5.88L11.94 3.5C12.05 3.5 12.15 3.55 12.23 3.62L14.4 5.75C14.47 5.82 14.51 5.91 14.51 6V16.14Z",
    fill: "#676879"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24268_9330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ccb95fc2.svg";
export { ForwardRef as ReactComponent };